import { Benefit } from '@/types/Benefits.type'

export type State = {
    likedBenefits: Benefit[] | null
    likedBenefitsLoaded: boolean
}

const state: State = {
    likedBenefits: null,
    likedBenefitsLoaded: false,
}

export default state
